/* Razvan Garage – punctele de fidelitate în coș și pe pagina „Punctele mele”.
   1. Soldul la zi: blocul [data-rg-puncte] are semnătura făcută de temă (data-c, data-t, data-s); se cere soldul de la
      RG Hub (wa.razvangarage.ro/api/puncte) și se schimbă numerele din pagină.
   2. „Folosește punctele”: RG Hub face un cod numai al clientului (o folosire, 30 de zile) cu tot soldul; codul se pune
      singur în coș, lângă codurile deja puse. */
(() => {
  if (window.rgPuncte) return;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const json = {'Content-Type': 'application/json', Accept: 'application/json'};
  const lei = (bani) => (bani / 100).toLocaleString('ro-RO', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + ' lei';
  const semn = (box) => new URLSearchParams({c: box.dataset.c, t: box.dataset.t, s: box.dataset.s});

  function arata(box, sold, astept) {
    box.querySelectorAll('[data-rg-puncte-sold]').forEach((el) => { el.textContent = sold.toLocaleString('ro-RO'); });
    box.querySelectorAll('[data-rg-puncte-lei]').forEach((el) => { el.textContent = lei(sold); });  // 100 puncte = 1 leu
    box.querySelectorAll('[data-rg-puncte-astept]').forEach((el) => {
      el.hidden = !astept;
      el.textContent = `(+${astept.toLocaleString('ro-RO')} în așteptare)`;
    });
    box.querySelectorAll('[data-rg-puncte-foloseste]').forEach((el) => { el.hidden = !(sold > 0); });
  }

  async function laZi() {
    for (const box of document.querySelectorAll('[data-rg-puncte][data-c]:not([data-rg-puncte-citit])')) {
      box.dataset.rgPuncteCitit = '1';
      try {
        const res = await fetch(`${box.dataset.url}/api/puncte?${semn(box)}`);
        const data = await res.json();
        if (res.ok && data.activ) arata(box, data.sold || 0, data.asteptare || 0);
      } catch (error) { /* rămân numerele din pagină */ }
    }
  }

  function mesaj(box, text) {
    const el = box.querySelector('[data-rg-puncte-msg]');
    if (el) { el.textContent = text; el.hidden = false; }
  }

  async function foloseste(button) {
    const box = button.closest('[data-rg-puncte]');
    if (!box || !box.dataset.c) return;
    button.disabled = true;
    try {
      const res = await fetch(`${box.dataset.url}/api/puncte/foloseste`, {method: 'POST', body: semn(box)});
      const data = await res.json();
      if (!res.ok || !data.cod) { mesaj(box, data.eroare || 'Nu am putut face codul. Încearcă din nou.'); return; }
      const cart = await (await fetch(root + 'cart.js', {headers: {Accept: 'application/json'}})).json();
      const coduri = (cart.discount_codes || []).map((d) => d.code).filter(Boolean);
      await fetch(root + 'cart/update.js', {method: 'POST', headers: json, body: JSON.stringify({discount: [...coduri, data.cod].join(',')})});
      arata(box, 0, 0);
      const pana = new Date(data.expira).toLocaleDateString('ro-RO');
      mesaj(box, `Am pus în coș codul ${data.cod} (−${lei(Math.round(data.valoare * 100))}). E valabil până pe ${pana}.`);
      const drawer = document.querySelector('cart-drawer');
      const items = document.querySelector('cart-items');
      if (drawer && typeof drawer.refresh === 'function') setTimeout(() => drawer.refresh(true), 1500);
      else if (items && typeof items.refresh === 'function') setTimeout(() => items.refresh(), 1500);
      else if (/\/cart\/?$/.test(location.pathname)) setTimeout(() => location.reload(), 1500);
    } catch (error) {
      mesaj(box, 'Nu am putut face codul acum. Încearcă peste câteva minute.');
    } finally {
      button.disabled = false;
    }
  }

  document.addEventListener('click', (evt) => {
    const button = evt.target.closest('[data-rg-puncte-foloseste]');
    if (button) foloseste(button);
  });
  const later = () => setTimeout(laZi, 600);
  ['on:cart-drawer:after-open', 'on:line-item:change', 'on:cart:add'].forEach((e) => document.addEventListener(e, later));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', laZi);
  else laZi();
  window.rgPuncte = {laZi};
})();
